import { type ErrorResponse } from '@/types';
import i18n from '@/i18n';

export const translateError = (errorResponse: ErrorResponse) => {
  if (!errorResponse) return i18n.t('GENERIC_ERROR');

  const { error, errorCode } = errorResponse;

  if (i18n.exists(errorCode)) {
    return i18n.t(errorCode);
  }

  return error || i18n.t('GENERIC_ERROR');
};
